var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchSidebar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_376_241178",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_376_241178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.301 13.9L8.71771 10.3167C8.39549 10.5389 8.0206 10.7167 7.59304 10.85C7.16504 10.9834 6.70104 11.05 6.20104 11.05C4.88993 11.05 3.77615 10.5916 2.85971 9.6747C1.94282 8.75825 1.48438 7.64448 1.48438 6.33337C1.48438 5.02225 1.94282 3.90825 2.85971 2.99137C3.77615 2.07492 4.88993 1.6167 6.20104 1.6167C7.51215 1.6167 8.62593 2.07492 9.54238 2.99137C10.4593 3.90825 10.9177 5.02225 10.9177 6.33337C10.9177 6.84448 10.851 7.30825 10.7177 7.7247C10.5844 8.14159 10.4066 8.50559 10.1844 8.8167L13.801 12.45C14.001 12.65 14.0984 12.8916 14.093 13.1747C14.0873 13.4583 13.9844 13.7 13.7844 13.9C13.5844 14.1 13.337 14.2 13.0424 14.2C12.7482 14.2 12.501 14.1 12.301 13.9ZM6.20104 8.95003C6.93438 8.95003 7.55393 8.69714 8.05971 8.19137C8.56504 7.68603 8.81771 7.0667 8.81771 6.33337C8.81771 5.60003 8.56504 4.98048 8.05971 4.4747C7.55393 3.96937 6.93438 3.7167 6.20104 3.7167C5.46771 3.7167 4.84838 3.96937 4.34304 4.4747C3.83726 4.98048 3.58438 5.60003 3.58438 6.33337C3.58438 7.0667 3.83726 7.68603 4.34304 8.19137C4.84838 8.69714 5.46771 8.95003 6.20104 8.95003Z",
    fill: "#3676F5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSidebar);
export default __webpack_public_path__ + "static/media/search-sidebar.114f6bb1789e8fa37ecafc32fb4e25f8.svg";
export { ForwardRef as ReactComponent };